import React, { useState, useEffect } from "react";
import { useAuth } from "@context/AuthContext";
import { useNotification } from "../common/NotificationContext";
import { db, storage } from "@lib/firebase";
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  collection,
  query,
  where,
  getDocs,
  addDoc,
  deleteDoc,
  orderBy,
  getDocs as getDocsFromCollection,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import {
  updateProfile,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { InputFieldProfile } from "../common/InputFieldProfile";
import { InputField, Button } from "@cakrawalajakarta/shared-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserEdit,
  faCamera,
  faLock,
  faQuestionCircle,
  faEye,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Timestamp } from "firebase/firestore";

export const Profile = ({ labelColor = "text-slate-800" }) => {
  const { user, logout } = useAuth();
  const { showNotification, showConfirm } = useNotification();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    namaDepan: "",
    namaBelakang: "",
    bibName: "",
    email: "",
    telepon: "",
    nomorIdentitas: "",
    tanggalLahir: "",
    golonganDarah: "",
    sizeJersey: "",
    gender: "",
    negara: "",
    provinsi: "",
    kota: "",
    alamat: "",
    alamatDomisili: "",
    grupPengkot: "",
    kontakDarurat: "",
    namaKontakDarurat: "",
    hubunganKontakDarurat: "",
  });
  const [loading, setLoading] = useState(false);
  const [activeMenu, setActiveMenu] = useState(() => {
    return localStorage.getItem("activeMenu") || "Ubah Profil";
  });
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [feedbackData, setFeedbackData] = useState({
    subject: "",
    message: "",
  });
  const [feedbackList, setFeedbackList] = useState([]);
  const [viewFeedback, setViewFeedback] = useState(null);
  const [editFeedback, setEditFeedback] = useState(null);
  const [stravaData, setStravaData] = useState(null);
  const [showStats, setShowStats] = useState(false);

  useEffect(() => {
    localStorage.setItem("activeMenu", activeMenu);
  }, [activeMenu]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!user) {
          return;
        }

        if (!user.emailVerified) {
          await logout();
          navigate("/login");
          return;
        }

        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          const fullName = data.namaLengkap || user.displayName || "";
          const [namaDepan, ...namaBelakang] = fullName.split(" ");
          setFormData({
            ...data,
            namaDepan,
            namaBelakang: namaBelakang.join(" "),
            alamatDomisili: data.alamatDomisili || "",
            grupPengkot: data.grupPengkot || "",
          });
          if (data.strava) {
            setStravaData(data.strava);
          }
        } else {
          const fullName = user.displayName || "";
          const [namaDepan, ...namaBelakang] = fullName.split(" ");
          setFormData({
            namaDepan,
            namaBelakang: namaBelakang.join(" "),
            email: user.email,
            bibName: "",
            telepon: "",
            nomorIdentitas: "",
            tanggalLahir: "",
            golonganDarah: "",
            sizeJersey: "",
            gender: "",
            negara: "",
            provinsi: "",
            kota: "",
            alamat: "",
            alamatDomisili: "",
            grupPengkot: "",
            kontakDarurat: "",
            namaKontakDarurat: "",
            hubunganKontakDarurat: "",
          });
          console.log(
            "Data user belum ada di Firestore, menggunakan displayName"
          );
        }

        try {
          const feedbackQuery = query(
            collection(db, "feedback"),
            where("uid", "==", user.uid),
            orderBy("createdAt", "desc")
          );
          const feedbackSnapshot = await getDocs(feedbackQuery);
          const feedbackData = feedbackSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setFeedbackList(feedbackData);
        } catch (feedbackErr) {
          console.error("Gagal mengambil feedback:", feedbackErr);
          if (
            feedbackErr.code === "failed-precondition" &&
            feedbackErr.message.includes("index")
          ) {
            showNotification(
              "error",
              "Gagal memuat masukan: Indeks Firestore diperlukan. Silakan hubungi admin."
            );
          } else {
            showNotification(
              "error",
              "Gagal memuat masukan. Silakan coba lagi nanti."
            );
          }
        }
      } catch (err) {
        console.error("Gagal mengambil data profil:", err);
        showNotification("error", "Gagal mengambil data pengguna.");
      }
    };

    fetchData();
  }, [user, logout, navigate, showNotification]);

  const handleConnectStrava = () => {
    const clientId = "156089";
    const redirectUri = "https://cakrawalajakarta.id/strava-callback";
    const scope = "read,activity:read_all,profile:read_all";
    const authUrl = `https://www.strava.com/oauth/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_type=code&scope=${encodeURIComponent(
      scope
    )}&approval_prompt=auto`;

    window.location.href = authUrl;
  };

  const handleDisconnectStrava = async () => {
    showConfirm(
      "Apakah Anda yakin ingin memutuskan koneksi dengan Strava?",
      async () => {
        setLoading(true);
        try {
          await updateDoc(doc(db, "users", user.uid), {
            strava: null,
          });
          setStravaData(null);
          setShowStats(false);
          showNotification("success", "Koneksi Strava berhasil diputus!");
        } catch (err) {
          console.error("Gagal memutuskan koneksi Strava:", err);
          showNotification(
            "error",
            "Gagal memutuskan koneksi Strava. Silakan coba lagi!"
          );
        } finally {
          setLoading(false);
        }
      },
      "Putuskan",
      "Batal"
    );
  };

  const toggleShowStats = () => {
    setShowStats((prev) => !prev);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Validasi nama depan dan nama belakang
      const fullName = `${formData.namaDepan} ${formData.namaBelakang}`.trim();
      if (!formData.namaDepan || !formData.namaBelakang) {
        showNotification(
          "error",
          "Nama depan dan nama belakang tidak boleh kosong!"
        );
        setLoading(false);
        return;
      }

      // Perbarui koleksi users
      await setDoc(
        doc(db, "users", user.uid),
        {
          ...formData,
          namaLengkap: fullName,
          email: user.email,
          updatedAt: Timestamp.now(),
        },
        { merge: true }
      );

      // Perbarui pendaftaran acara
      const eventsSnapshot = await getDocsFromCollection(
        collection(db, "events")
      );
      let updatedRegistrations = 0;

      const registrationData = {
        namaLengkap: fullName,
        namaDepan: formData.namaDepan,
        namaBelakang: formData.namaBelakang,
        bibName: formData.bibName,
        email: formData.email,
        telepon: formData.telepon,
        nomorIdentitas: formData.nomorIdentitas,
        tanggalLahir: formData.tanggalLahir,
        golonganDarah: formData.golonganDarah,
        sizeJersey: formData.sizeJersey,
        gender: formData.gender,
        negara: formData.negara,
        provinsi: formData.provinsi,
        kota: formData.kota,
        alamat: formData.alamat,
        alamatDomisili: formData.alamatDomisili,
        grupPengkot: formData.grupPengkot,
        kontakDarurat: formData.kontakDarurat,
        namaKontakDarurat: formData.namaKontakDarurat,
        hubunganKontakDarurat: formData.hubunganKontakDarurat,
        updatedAt: Timestamp.now(),
      };

      for (const eventDoc of eventsSnapshot.docs) {
        const { collectionName } = eventDoc.data();
        const registrationQuery = query(
          collection(db, collectionName),
          where("uid", "==", user.uid)
        );
        const registrationSnapshot = await getDocs(registrationQuery);

        if (!registrationSnapshot.empty) {
          for (const registrationDoc of registrationSnapshot.docs) {
            await updateDoc(registrationDoc.ref, registrationData);
            updatedRegistrations++;
            console.log(
              `Berhasil memperbarui pendaftaran di ${collectionName} untuk orderId=${registrationDoc.id}`
            );
          }
        }
      }

      if (updatedRegistrations > 0) {
        showNotification(
          "success",
          "Profil dan pendaftaran acara berhasil diperbarui!"
        );
      } else {
        showNotification("success", "Profil berhasil diperbarui!");
      }
    } catch (err) {
      console.error("Gagal menyimpan data:", err);
      showNotification("error", "Terjadi kesalahan saat menyimpan data!");
    } finally {
      setLoading(false);
    }
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith("image/")) {
        showNotification("error", "File harus berupa gambar (jpg, png, dll.)!");
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        showNotification("error", "Ukuran gambar maksimal 5MB!");
        return;
      }
      setPhotoFile(file);
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  const handlePhotoSubmit = async (e) => {
    e.preventDefault();
    if (!photoFile) {
      showNotification("error", "Pilih gambar terlebih dahulu!");
      return;
    }

    setLoading(true);
    try {
      const storageRef = ref(storage, `profilePictures/${user.uid}`);
      await uploadBytes(storageRef, photoFile);
      const photoURL = await getDownloadURL(storageRef);

      await updateProfile(user, { photoURL });

      await updateDoc(doc(db, "users", user.uid), { photoURL });

      showNotification("success", "Foto profil berhasil diperbarui!");
      setPhotoFile(null);
      setPhotoPreview(null);
    } catch (err) {
      console.error("Gagal mengunggah foto profil:", err);
      showNotification(
        "error",
        "Gagal mengunggah foto profil. Silakan coba lagi!"
      );
    } finally {
      setLoading(false);
    }
  };

  const handlePhotoCancel = () => {
    setPhotoFile(null);
    setPhotoPreview(null);
  };

  const handlePasswordChange = (e) => {
    setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!passwordData.currentPassword) {
        showNotification("error", "Masukkan kata sandi lama!");
        setLoading(false);
        return;
      }
      if (passwordData.newPassword.length < 6) {
        showNotification("error", "Kata sandi baru harus minimal 6 karakter!");
        setLoading(false);
        return;
      }
      if (passwordData.newPassword !== passwordData.confirmPassword) {
        showNotification(
          "error",
          "Kata sandi baru dan konfirmasi tidak cocok!"
        );
        setLoading(false);
        return;
      }

      const credential = EmailAuthProvider.credential(
        user.email,
        passwordData.currentPassword
      );
      await reauthenticateWithCredential(user, credential);

      await updatePassword(user, passwordData.newPassword);

      await updateDoc(doc(db, "users", user.uid), {
        lastPasswordChange: Timestamp.now(),
      });

      showNotification("success", "Kata sandi berhasil diperbarui!");
      setPasswordData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    } catch (err) {
      console.error("Gagal memperbarui kata sandi:", err);
      if (err.code === "auth/wrong-password") {
        showNotification("error", "Kata sandi lama salah!");
      } else if (err.code === "auth/too-many-requests") {
        showNotification("error", "Terlalu banyak percobaan. Coba lagi nanti!");
      } else {
        showNotification(
          "error",
          "Gagal memperbarui kata sandi. Silakan coba lagi!"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordCancel = () => {
    setPasswordData({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
  };

  const handleFeedbackChange = (e) => {
    setFeedbackData({ ...feedbackData, [e.target.name]: e.target.value });
  };

  const handleFeedbackSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!feedbackData.subject) {
        showNotification("error", "Subjek tidak boleh kosong!");
        setLoading(false);
        return;
      }
      if (!feedbackData.message) {
        showNotification("error", "Pesan tidak boleh kosong!");
        setLoading(false);
        return;
      }
      if (feedbackData.subject.length > 100) {
        showNotification("error", "Subjek maksimal 100 karakter!");
        setLoading(false);
        return;
      }
      if (feedbackData.message.length > 1000) {
        showNotification("error", "Pesan maksimal 1000 karakter!");
        setLoading(false);
        return;
      }

      const namaLengkap =
        formData.namaLengkap ||
        user.displayName ||
        `${formData.namaDepan} ${formData.namaBelakang}`.trim() ||
        user.email;
      const feedbackDataToSave = {
        uid: user.uid,
        email: user.email,
        namaLengkap,
        subject: feedbackData.subject,
        message: feedbackData.message,
        createdAt: Timestamp.now(),
        isResolved: false,
      };

      if (formData.telepon) {
        feedbackDataToSave.telepon = formData.telepon;
      }

      const feedbackRef = await addDoc(
        collection(db, "feedback"),
        feedbackDataToSave
      );
      setFeedbackList([
        {
          id: feedbackRef.id,
          ...feedbackDataToSave,
        },
        ...feedbackList,
      ]);

      showNotification("success", "Masukan berhasil dikirim!");
      setFeedbackData({ subject: "", message: "" });
    } catch (err) {
      console.error("Gagal mengirim masukan:", err);
      showNotification("error", "Gagal mengirim masukan. Silakan coba lagi!");
    } finally {
      setLoading(false);
    }
  };

  const handleFeedbackCancel = () => {
    setFeedbackData({ subject: "", message: "" });
  };

  const handleFeedbackView = (feedback) => {
    setViewFeedback(feedback);
  };

  const handleFeedbackEdit = (feedback) => {
    setEditFeedback({
      id: feedback.id,
      subject: feedback.subject,
      message: feedback.message,
    });
  };

  const handleEditFeedbackChange = (e) => {
    setEditFeedback({ ...editFeedback, [e.target.name]: e.target.value });
  };

  const handleEditFeedbackSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!editFeedback.subject) {
        showNotification("error", "Subjek tidak boleh kosong!");
        setLoading(false);
        return;
      }
      if (!editFeedback.message) {
        showNotification("error", "Pesan tidak boleh kosong!");
        setLoading(false);
        return;
      }
      if (editFeedback.subject.length > 100) {
        showNotification("error", "Subjek maksimal 100 karakter!");
        setLoading(false);
        return;
      }
      if (editFeedback.message.length > 1000) {
        showNotification("error", "Pesan maksimal 1000 karakter!");
        setLoading(false);
        return;
      }

      const feedbackRef = doc(db, "feedback", editFeedback.id);
      await updateDoc(feedbackRef, {
        subject: editFeedback.subject,
        message: editFeedback.message,
        updatedAt: Timestamp.now(),
      });

      setFeedbackList(
        feedbackList.map((feedback) =>
          feedback.id === editFeedback.id
            ? {
                ...feedback,
                subject: editFeedback.subject,
                message: editFeedback.message,
                updatedAt: Timestamp.now(),
              }
            : feedback
        )
      );

      showNotification("success", "Masukan berhasil diperbarui!");
      setEditFeedback(null);
    } catch (err) {
      console.error("Gagal memperbarui masukan:", err);
      showNotification(
        "error",
        "Gagal memperbarui masukan. Silakan coba lagi!"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEditFeedbackCancel = () => {
    setEditFeedback(null);
  };

  const handleFeedbackDelete = async (feedbackId) => {
    showConfirm(
      "Apakah Anda yakin ingin menghapus masukan ini?",
      async () => {
        setLoading(true);
        try {
          await deleteDoc(doc(db, "feedback", feedbackId));
          setFeedbackList(
            feedbackList.filter((feedback) => feedback.id !== feedbackId)
          );
          showNotification("success", "Masukan berhasil dihapus!");
        } catch (err) {
          console.error("Gagal menghapus masukan:", err);
          showNotification(
            "error",
            "Gagal menghapus masukan. Silakan coba lagi!"
          );
        } finally {
          setLoading(false);
        }
      },
      "Hapus",
      "Batal"
    );
  };

  const isGoogleLogin = user?.providerData.some(
    (provider) => provider.providerId === "google.com"
  );

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.toDate();
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()} ${date
      .getHours()
      .toString()
      .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;
  };

  const menus = [
    { name: "Ubah Profil", icon: faUserEdit },
    { name: "Ganti Foto Profil", icon: faCamera },
    { name: "Ganti Kata Sandi", icon: faLock },
    // { name: "Hubungkan Aplikasi", icon: faPlug }, // Temporarily hidden
    { name: "Kirim Masukan", icon: faQuestionCircle },
  ];

  const renderContent = () => {
    switch (activeMenu) {
      case "Ubah Profil":
        return (
          <div className="bg-white rounded-xl border border-slate-200 p-4">
            <h2 className="text-xl font-semibold text-slate-800 mb-4">
              Ubah Profil JOTR
            </h2>
            <div className="flex justify-center mb-4">
              <img
                src={
                  user?.photoURL ||
                  "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"
                }
                alt="Avatar"
                className="w-24 h-24 rounded-full border-4 border-gray-200"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
                }}
              />
            </div>
            <p className="text-lg mb-6 text-center text-slate-800">
              Halo,{" "}
              <strong>
                {`${formData.namaDepan} ${formData.namaBelakang}` ||
                  user?.displayName ||
                  user.email}
              </strong>
            </p>
            <form onSubmit={handleSubmit}>
              <InputFieldProfile
                formData={formData}
                handleChange={handleChange}
                isFormDisabled={loading}
                labelColor={labelColor}
              />
              <div className="flex justify-center">
                <Button
                  type="submit"
                  variant="none"
                  className="px-8 py-2 flex bg-lime-600 text-white rounded-xl hover:bg-lime-700 transition-colors duration-200 max-w-xs"
                  disabled={loading}
                >
                  {loading ? "Menyimpan..." : "Simpan Data"}
                </Button>
              </div>
            </form>
          </div>
        );
      case "Ganti Foto Profil":
        return (
          <div className="bg-white rounded-xl border border-slate-200 p-4">
            <h2 className="text-xl font-semibold text-slate-800 mb-4">
              Ganti Foto Profil
            </h2>
            <div className="flex justify-center mb-4">
              <img
                src={
                  photoPreview ||
                  user?.photoURL ||
                  "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y"
                }
                alt="Avatar Preview"
                className="w-32 h-32 rounded-full border-4 border-gray-200 object-cover"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
                }}
              />
            </div>
            <form onSubmit={handlePhotoSubmit}>
              <InputField
                label="Pilih Gambar"
                name="photo"
                type="file"
                onChange={handlePhotoChange}
                accept="image/*"
                disabled={loading}
                labelColor="text-slate-800"
              />
              <div className="flex justify-center gap-4 mt-4">
                <Button
                  type="submit"
                  variant="none"
                  className="px-8 py-2 flex bg-lime-600 text-white rounded-xl hover:bg-lime-700 transition-colors duration-200"
                  disabled={loading}
                >
                  {loading ? "Mengunggah..." : "Unggah"}
                </Button>
                {photoFile && (
                  <Button
                    type="button"
                    variant="none"
                    onClick={handlePhotoCancel}
                    className="px-4 py-2 flex bg-gray-300 text-slate-800 rounded-lg hover:bg-gray-400 transition-colors duration-200"
                  >
                    Batal
                  </Button>
                )}
              </div>
            </form>
          </div>
        );
      case "Ganti Kata Sandi":
        return (
          <div className="bg-white rounded-xl border border-slate-200 p-4">
            <h2 className="text-xl font-semibold text-slate-800 mb-4">
              Ganti Kata Sandi
            </h2>
            {isGoogleLogin ? (
              <p className="text-gray-600">
                Akun Anda menggunakan Google Login. Kata sandi dikelola oleh
                Google.
              </p>
            ) : (
              <form onSubmit={handlePasswordSubmit}>
                <InputField
                  label="Kata Sandi Lama"
                  name="currentPassword"
                  type="password"
                  value={passwordData.currentPassword}
                  onChange={handlePasswordChange}
                  placeholder="Masukkan kata sandi lama"
                  required
                  disabled={loading}
                  labelColor={labelColor}
                />
                <InputField
                  label="Kata Sandi Baru"
                  name="newPassword"
                  type="password"
                  value={passwordData.newPassword}
                  onChange={handlePasswordChange}
                  placeholder="Masukkan kata sandi baru"
                  required
                  disabled={loading}
                  labelColor={labelColor}
                />
                <InputField
                  label="Konfirmasi Kata Sandi"
                  name="confirmPassword"
                  type="password"
                  value={passwordData.confirmPassword}
                  onChange={handlePasswordChange}
                  placeholder="Konfirmasi kata sandi baru"
                  required
                  disabled={loading}
                  labelColor={labelColor}
                />
                <div className="flex justify-center gap-4 mt-4">
                  <Button
                    type="submit"
                    variant="none"
                    className="px-4 py-2 flex bg-lime-600 text-white rounded-xl hover:bg-lime-700 transition-colors duration-200"
                    disabled={loading}
                  >
                    {loading ? "Menyimpan..." : "Simpan"}
                  </Button>
                  <Button
                    type="button"
                    variant="none"
                    onClick={handlePasswordCancel}
                    className="px-4 py-2 flex bg-gray-300 text-slate-800 rounded-xl hover:bg-gray-400 transition-colors duration-200"
                  >
                    Batal
                  </Button>
                </div>
              </form>
            )}
          </div>
        );
      case "Hubungkan Aplikasi":
        return (
          <div>
            <div className="bg-white rounded-xl border border-slate-200 p-4 mb-4">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">
                {stravaData ? "Aplikasi Terhubung" : "Hubungkan Aplikasi"}
              </h2>
              <div className="flex flex-col items-center">
                {stravaData ? (
                  <div className="text-center w-full space-y-6">
                    <div className="mb-4 space-y-2">
                      <p>
                        <strong>Athlete ID:</strong> {stravaData.athleteId}
                      </p>
                      {stravaData.athlete && (
                        <p>
                          <strong>Nama:</strong> {stravaData.athlete.firstname}{" "}
                          {stravaData.athlete.lastname}
                        </p>
                      )}
                    </div>
                    <div className="flex flex-row justify-center gap-3 flex-wrap">
                      <button
                        onClick={handleDisconnectStrava}
                        className="px-6 py-2 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors duration-200 font-semibold w-full sm:w-auto"
                        disabled={loading}
                      >
                        {loading ? "Memutuskan..." : "Putuskan Koneksi Strava"}
                      </button>
                      <button
                        onClick={toggleShowStats}
                        className="px-6 py-2 bg-orange-600 text-white rounded-xl hover:bg-orange-700 transition-colors duration-200 font-semibold w-full sm:w-auto"
                      >
                        {showStats
                          ? "Sembunyikan Statistik Strava"
                          : "Lihat Statistik Strava"}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="w-full">
                    <div className="text-gray-600 mb-6">
                      Hubungkan akun Anda dengan Strava untuk berbagi aktivitas
                      olahraga.
                    </div>
                    <div className="flex items-start">
                      <button
                        onClick={handleConnectStrava}
                        className="px-4 py-2 bg-orange-600 text-white rounded-xl hover:bg-orange-700 transition-colors duration-200 font-semibold"
                        disabled={loading}
                      >
                        {loading
                          ? "Menghubungkan..."
                          : "Hubungkan dengan Strava"}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {showStats && stravaData && <StravaStats stravaData={stravaData} />}
          </div>
        );
      case "Kirim Masukan":
        return (
          <div>
            <div className="bg-white rounded-xl border border-slate-200 p-4 mb-4">
              <h2 className="text-xl font-semibold text-slate-800 mb-4">
                Kirim Masukan
              </h2>
              <p className="text-gray-600 mb-4">
                Kirim masukan, laporan bug, atau pertanyaan Anda.
              </p>
              <form onSubmit={handleFeedbackSubmit}>
                <InputField
                  label="Subjek"
                  name="subject"
                  type="text"
                  value={feedbackData.subject}
                  onChange={handleFeedbackChange}
                  placeholder="Masukkan subjek masukan"
                  maxLength={100}
                  required
                  disabled={loading}
                  labelColor={labelColor}
                />
                <InputField
                  label="Pesan"
                  name="message"
                  type="textarea"
                  value={feedbackData.message}
                  onChange={handleFeedbackChange}
                  placeholder="Tulis masukan atau pertanyaan Anda"
                  maxLength={1000}
                  required
                  disabled={loading}
                  labelColor={labelColor}
                  className="resize-y h-32"
                />
                <div className="flex justify-center gap-3 mt-4">
                  <Button
                    type="submit"
                    variant="none"
                    className="px-8 py-2 flex bg-lime-600 text-white rounded-xl hover:bg-lime-700 transition-colors duration-200"
                    disabled={loading}
                  >
                    {loading ? "Mengirim..." : "Kirim"}
                  </Button>
                  <Button
                    type="button"
                    variant="none"
                    onClick={handleFeedbackCancel}
                    className="px-8 py-2 flex bg-gray-300 text-slate-800 rounded-xl hover:bg-gray-400 transition-colors duration-200"
                    disabled={loading}
                  >
                    Batal
                  </Button>
                </div>
              </form>
            </div>

            <div className="bg-white rounded-xl border border-slate-200">
              <h3 className="text-lg font-semibold text-slate-800 mb-4 p-4">
                Riwayat Masukan
              </h3>
              {feedbackList.length === 0 ? (
                <p className="text-gray-600 text-center pb-4">
                  Belum ada masukan yang dikirim.
                </p>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full table-auto divide-y divide-gray-200">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="px-8 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Subjek
                        </th>
                        <th className="px-4 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Pesan
                        </th>
                        <th className="px-4 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Tanggal
                        </th>
                        <th className="px-4 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Status
                        </th>
                        <th className="px-4 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Aksi
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {feedbackList.map((feedback) => (
                        <tr
                          key={feedback.id}
                          className="border-b border-gray-200"
                        >
                          <td className="px-8 py-4 text-sm text-gray-600">
                            {feedback.subject}
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-600">
                            {feedback.message.substring(0, 100) +
                              (feedback.message.length > 100 ? "..." : "")}
                          </td>
                          <td className="px-4 py-4 text-sm text-gray-600">
                            {formatDate(feedback.createdAt)}
                          </td>
                          <td className="px-4 py-4 text-sm">
                            <span
                              className={`px-2 py-1 rounded-md text-xs font-medium ${
                                feedback.isResolved
                                  ? "bg-green-100 text-green-800"
                                  : "bg-yellow-100 text-yellow-800"
                              }`}
                            >
                              {feedback.isResolved ? "Resolved" : "Pending"}
                            </span>
                          </td>
                          <td className="px-4 py-2 text-sm whitespace-nowrap">
                            <button
                              onClick={() => handleFeedbackView(feedback)}
                              className="text-lime-600 hover:text-lime-800 mr-3"
                              disabled={loading}
                            >
                              <FontAwesomeIcon icon={faEye} />
                            </button>
                            <button
                              onClick={() => handleFeedbackEdit(feedback)}
                              className="text-indigo-600 hover:text-indigo-900 mr-3"
                              disabled={loading}
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </button>
                            <button
                              onClick={() => handleFeedbackDelete(feedback.id)}
                              className="text-red-600 hover:text-red-900"
                              disabled={loading}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {viewFeedback && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 transition-opacity duration-300">
                <div className="bg-white rounded-xl border border-slate-200 p-4 w-full max-w-md max-h-[80vh] overflow-y-auto">
                  <h3 className="text-lg font-semibold text-slate-800 mb-4">
                    Detail Masukan
                  </h3>
                  <div className="space-y-2 text-sm text-gray-600">
                    <p>
                      <strong>Subjek:</strong> {viewFeedback.subject}
                    </p>
                    <p>
                      <strong>Pesan:</strong> {viewFeedback.message}
                    </p>
                    <p>
                      <strong>Tanggal:</strong>{" "}
                      {formatDate(viewFeedback.createdAt)}
                    </p>
                    <p>
                      <strong>Status:</strong>{" "}
                      {viewFeedback.isResolved ? "Resolved" : "Pending"}
                    </p>
                  </div>
                  <div className="flex justify-center mt-6">
                    <button
                      onClick={() => setViewFeedback(null)}
                      className="px-4 py-2 bg-gray-300 text-slate-800 rounded-xl hover:bg-gray-400 transition-colors duration-200 w-full max-w-xs"
                      disabled={loading}
                    >
                      Tutup
                    </button>
                  </div>
                </div>
              </div>
            )}

            {editFeedback && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 transition-opacity duration-300">
                <div className="bg-white rounded-xl border border-slate-200 p-4 w-full max-w-md max-h-[80vh] overflow-y-auto">
                  <h3 className="text-lg font-semibold text-slate-800 mb-4">
                    Edit Masukan
                  </h3>
                  <form onSubmit={handleEditFeedbackSubmit}>
                    <InputField
                      label="Subjek"
                      name="subject"
                      type="text"
                      value={editFeedback.subject}
                      onChange={handleEditFeedbackChange}
                      placeholder="Masukkan subjek masukan"
                      maxLength={100}
                      required
                      disabled={loading}
                      labelColor={labelColor}
                    />
                    <InputField
                      label="Pesan"
                      name="message"
                      type="textarea"
                      value={editFeedback.message}
                      onChange={handleEditFeedbackChange}
                      placeholder="Tulis masukan atau pertanyaan Anda"
                      maxLength={1000}
                      required
                      disabled={loading}
                      labelColor={labelColor}
                      className="resize-y h-32"
                    />
                    <div className="flex justify-center gap-3 mt-6">
                      <Button
                        type="submit"
                        variant="none"
                        className="px-4 py-2 flex bg-lime-600 text-white rounded-xl hover:bg-lime-700 transition-colors duration-200 w-full max-w-[120px]"
                        disabled={loading}
                      >
                        {loading ? "Menyimpan..." : "Simpan"}
                      </Button>
                      <Button
                        type="button"
                        variant="none"
                        onClick={handleEditFeedbackCancel}
                        className="px-4 py-2 flex bg-gray-300 text-slate-800 rounded-xl hover:bg-gray-400 transition-colors duration-200 w-full max-w-[120px]"
                        disabled={loading}
                      >
                        Batal
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <section className="min-h-screen bg-white px-4 py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="w-full md:w-64 bg-white rounded-xl border border-slate-200 p-4 block">
            <ul>
              {menus.map((menu) => (
                <li key={menu.name}>
                  <button
                    onClick={() => {
                      setActiveMenu(menu.name);
                    }}
                    className={`w-full flex items-center gap-3 px-4 py-2 mb-1 text-md font-medium rounded-xl transition-colors duration-200 ${
                      activeMenu === menu.name
                        ? "bg-lime-600 text-white"
                        : "text-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    <FontAwesomeIcon icon={menu.icon} />
                    {menu.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="flex-1">{renderContent()}</div>
        </div>
      </div>
    </section>
  );
};
